import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-fabrics-grps',
  templateUrl: './fabrics-grps.component.html',
  styleUrls: ['./fabrics-grps.component.css']
})
export class FabricsGrpsComponent implements OnInit {
    public setting?: Setting;

    public itemsListFabricGroups: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1243))[0];
    }

    private async loadFabricGroups(): Promise<void> {
        this.itemsListFabricGroups = await this.datatask.Post(1240);
    }

    private async init() {
        this.loadSetting();
        this.loadFabricGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
